import React, { useState, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { WelletContext } from '../../../context/WelletContext';
import { format, parseISO } from 'date-fns';
import { getLocale } from '../../../helpers/dates';
import { useActivities } from '../../../hooks/useActivities';
import { SkeletonPoints } from '../../../components/Skeletons/SkeletonPoints';
import { getAssociateStatusAccount } from '../../../actions/associatesActions';
import { useTranslation } from 'react-i18next';
import ContentApp from '../../../components/ContentApp';
import StatusTracker from '../../../components/Points/StatusTracker/StatusTracker';
import StatusCommissions from '../../../components/Points/StatusCommissions/StatusCommissions';
import Activity from '../../../components/Activities/Activity/Activity';
import EmptyActivity from '../../../components/Common/EmptyActivity/EmptyActivity';
import ActivitiesHome from '../../../components/Activities/ActivitiesHome/ActivitiesHome';
import HeaderUserPoints from '../../../components/Points/HeaderUserPoints';
import Header from '../../../components/Common/Header/Header';


const PointsScreen = ({ history }) => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.associates.user);
  const affiliatePoints = user.currentLoyalty.points;
  const categoryName = user.currentLoyalty.category;
  const jwt = useSelector((state) => state.associates.jwt);
  const dispatch = useDispatch();
  const welletContext = useContext(WelletContext);
  const [categories, setCategories] = useState(null);
  const [loading, setLoading] = useState(true);
  const app = useSelector((state) => state.app);
  const locale = getLocale(app.language);

  const [expirationDate, setExpirationDate] = useState(null);

  const [lastUpdate, setLastUpdate] = useState(null);

  const getCategories = async () => {
    setLoading(true);
    try {
      const response = await welletContext.apis.tickets.get(`associates/getAllsalesCategory`);
      if (response.status === 200) {
        const sortedCategories = response.data.categoriesList.sort((a, b) => b.level - a.level);
        setCategories(sortedCategories);
        const expirationDate = response.data.nextReCategorization;

        setExpirationDate(expirationDate);

        const lastUpdate = response.data.lastUpdate;
        setLastUpdate(lastUpdate);
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(getAssociateStatusAccount(welletContext, jwt));
  }, [jwt]);

  const pointsInfoData = useActivities({
    pageSize: 5,
    endpoint: '/associates/getpoints',
    api: welletContext.apis.tickets,
  });

  useEffect(() => {
    if (!categories) {
      getCategories();
    }
  }, []);

  return (
    <>
      <Header title={app.titleWeb} />
      <ContentApp >
        <div className='points mt-2 mb-2'>
          <HeaderUserPoints
            user={user}
            expirationDate={expirationDate}
            category={categoryName}
            points={affiliatePoints}
          />
          {!loading ? (
            <>
              <div className={`card mt-2`}>
                <StatusTracker
                  title={t('leaderboard')}
                  points={Number(affiliatePoints)}
                  categories={categories}
                  loading={loading}
                  categoryName={categoryName}
                />
              </div>

              <div className='mt-2'>
                <ActivitiesHome
                  title={<div className='bold'>{t('recentAccountActivities')}</div>}
                  linkTitle={
                    pointsInfoData?.activities?.length === 5 ? t('allAccountActivity') : null
                  }
                  pathName={'/points-activities'}
                  history={history}
                  children={
                    pointsInfoData?.activities?.length === 0 ? (
                      <EmptyActivity
                        title={t('noPoints')}
                        subtitle={t('noPointsDescription')}
                        icon={'notification'}
                      />
                    ) : (
                      pointsInfoData?.activities?.map((p, index) => (
                        <Activity
                          key={index}
                          loading={pointsInfoData.loading}
                          hasMore={pointsInfoData.hasMore}
                          loadMore={pointsInfoData.loadMore}
                          title={
                            <div className='bold'>
                              {t('pointsReservation')} {p.referenceCode}
                            </div>
                          }
                          subtitle={<div className='text-secondary semi-bold'>{p.showName}</div>}
                          item2={
                            <div className='bold'>{`${
                              p.points > 0 ? `+ ${p.points}` : `- ${Math.abs(p.points)}`
                            }`}</div>
                          }
                          item3={
                            <div className='text-secondary semi-bold text-right'>
                              {format(parseISO(p.operationDate), 'dd MMM', {
                                locale,
                              })}
                            </div>
                          }
                          className={`${
                            index === pointsInfoData.activities.length - 1 ? '' : 'feed-item-border'
                          } `}
                        />
                      ))
                    )
                  }
                />
              </div>
              <div className='mt-2'>
                <StatusCommissions
                  categoryName={categoryName}
                  categories={categories}
                  lastUpdate={lastUpdate}
                  title={
                    <>
                      {t('discounts')} {app.name} {t('byStatus')}
                    </>
                  }
                />
              </div>
            </>
          ) : (
            SkeletonPoints()
          )}
        </div>

      </ContentApp>
    </>
  );
};

export default PointsScreen;
